<div class="jd-container">
  <mat-card class="jd-card" style="padding: 60px 48px;">
    <div class="jd-card-content">
      <mat-icon class="jd-icon">agriculture</mat-icon>
      <h2>Connect John Deere Account</h2>
      <p class="jd-description">
        Connect your John Deere Operational Center account to automatically sync your field operation data to Precision Gateway.
      </p>

      <button mat-raised-button color="primary" class="jd-button" (click)="connect()" [disabled]="loading">
        <mat-icon *ngIf="!loading">link</mat-icon>
        <span *ngIf="!loading">Connect to John Deere</span>
        <span *ngIf="loading">Redirecting...</span>
      </button>

      <p class="jd-error" *ngIf="error">{{ error }}</p>
    </div>
  </mat-card>
</div>
